 <template>
<p class="text-left">{{ 'إظهار صفحة ' + data.current_page + ' من ' + data.last_page + ' و إجمالى عدد البيانات' + ' ' + data.total }}</p>

</template>

<script>
    export default {
        components: {
        },
        props: {
            data: {
                type: Object,
                default: {
                    current_page: 0,
                    data: {},
                    first_page_url: null,
                    from: 0,
                    next_page_url: null,
                    path: null,
                    per_page: 0,
                    prev_page_url: null,
                    to: 0
                }
            }
        },
        data () {
            return {
            }
        },
        computed: {
            trans(){
            return this.$store.getters.GET_TRANS;
            }
        },
        mounted() {

        },
        methods: {

            getIndexData(page){
                this.$emit('getIndexData', page);
            },
            doNothing(){
                return;
            },
		},
        watch: {

        },
    }
</script>




